<template>
  <v-text-field
    ref="input"
    class="white inline-error"
    style="width: 298px;"
    readonly outlined persistent-placeholder persistent-hint
    :hint="hint"
    :clearable="clearable"
    :disabled="disabled"
    :dense="dense"
    :label="label"
    :rules="rules"
    :value="value ? format(value) : null"
    @click:append="show = !show"
    @click:clear="$emit('input', null)"
    @keydown.enter="show = !show"
    @keydown.space="show = !show"
  >
    <template v-slot:append>
      <div>
        <v-icon style="color: inherit;" v-html="mdiCalendar" />

        <!-- We put the menu component in here so classes and styles can apply directly to the root element -->
        <v-menu
          v-if="!disabled"
          offset-y min-width="auto"
          :activator="$el"
          :close-on-content-click="false"
          v-model="show"
        >
          <v-date-picker no-title scrollable :value="value" @input="v => $emit('input', v)">
            <v-spacer />
            <v-btn text color="primary" @click="show = false">Close</v-btn>
          </v-date-picker>
        </v-menu>
      </div>
    </template>
  </v-text-field>
</template>


<script>
import { format } from '@/utils/time.js';
import { mdiCalendar } from '@mdi/js';

export default {
  name: 'input-date',

  props: {
    value: String,
    label: String,
    clearable: Boolean,
    dense: Boolean,
    disabled: Boolean,
    rules: Array,
    hint: String,
    format: {
      type: Function,
      default: v => `${format(v, 'weekday', 'UTC', 'en-US')}, ${format(v, 'long-date', 'UTC', 'en-US')}`
    }
  },

  data() {
    return {
      show: false
    };
  },

  created() {
    Object.assign(this, { mdiCalendar });
  }
}
</script>
